{
  "en": {
    "customer": {
      "actions": {
        "addCompany": "Add organisation",
        "addCustomer": "Add Customer",
        "addSecondaryContact": "Add secondary contact",
        "add_email_address": "Add email address",
        "bulk_import": "Import customers",
        "cancel": "Undo",
        "changeProfilePicture": "Change Profile Picture",
        "createNewCustomer": "Add new customer...",
        "goToCustomerProfile": "Go to customer contact page",
        "new": "Customer",
        "profilePictureFormat": "Image should be at least <strong>300x300px</strong>",
        "removeCompany": "Remove Organisation details",
        "removeCustomer": "Unassign this customer",
        "removeSecondaryContact": "Remove secondary contact",
        "save": "Save",
        "searchCustomer": "Search Customer",
        "submit": "Save",
        "uploadProfilePicture": "Upload a Profile Picture"
      },
      "attributes": {
        "address": "Address",
        "birth_date": "Date of birth",
        "categories": {
          "enduser": "Buyer-Occupier",
          "investor": "Investor"
        },
        "category": "Customer Type",
        "company_name": "Organisation name",
        "company_vat": "VAT number",
        "email_address": "Email",
        "email_address_secondary": "Email secondary contact",
        "email_notifications_interval": {
          "daily": "Once per day (around noon)",
          "hourly": "Every hour",
          "twice_daily": "Twice per day (noon/evening)",
          "weekly": "Once per week (Monday noon)"
        },
        "first_name": "First name",
        "iban": "IBAN",
        "internal_note": "Internal Note",
        "language": "Language",
        "last_name": "Last name",
        "phone_landline": "Landline number",
        "phone_mobile": "Mobile number",
        "status": "Status"
      },
      "import": {
        "fill_customer_info": "Fill in template with customer information",
        "fix_file_upload_customer": "Please fix the issues and upload the file again.</br>Existing customers will not be removed, but will be updated if anything changed in the file for that customer since last upload."
      },
      "labels": {
        "customerAddedState": "<b>Not invited yet.</b> An invitation email will be sent once {name} gets access to an assigned unit.",
        "customerAddedStateNoEmailAddress": "<b>No known email address.</b> An email address is needed for giving {name} access to an assigned unit.",
        "display": "Display",
        "hasAccessToUnit": "Has online access to unit",
        "information": "Your Information",
        "noCustomersYet": "No customers on the platform yet",
        "noEmailAddress": "No email address",
        "noProject": "No project yet assigned",
        "noUnits": "No units yet assigned",
        "notSharedWithCustomer": "Not visible for customer",
        "notificationDisclaimer": "Whenever there is new content available for you, you'll receive a notification. If you haven't read these notifications on the platform yet, they will be bundled and sent out in an email. Below you can turn off notifications about certain topics and increase/decrease the frequency of the emails.",
        "onPlatform": "On Platform",
        "otherSettings": "Other Settings",
        "password": "Password",
        "primaryContact": "Your details",
        "project": "Project",
        "secondaryContact": "Secondary contact",
        "sharedWithCustomer": "Visible for customer",
        "sorting": "Sorting",
        "units": "Units",
        "viaEmail": "Via E-mail"
      },
      "messages": {
        "integrationUpdateInformation": "Please contact us if you would like to update certain information.",
        "userlessProfileNotice": "This profile does not have an email address linked."
      },
      "toasts": {
        "birthday": "Happy birthday, {first_name}!",
        "create": "Customer added",
        "delete": "Customer deleted",
        "update": "Customer updated",
        "upload": "All customers successfully imported"
      },
      "validation": {
        "needFirstName": "First name required",
        "needFirstNameSecondary": "First name secondary contact required",
        "needLastName": "Last name required",
        "needLastNameSecondary": "Last name secondary contact required"
      }
    }
  }
}
